import React from 'react';

import { Separator } from '@epoch-ui/components/Separator';

import { useGuestSideSheetContext } from '../guestSideSheetContext';

export const ExternalGuestSideSheetContentSection = (): React.ReactNode => {
  const {
    guestData: { guest }
  } = useGuestSideSheetContext();
  return (
    <>
      <Separator />
      <div className="tw-flex tw-flex-col tw-gap-6">
        <div className="tw-text-sm tw-font-normal tw-leading-5 tw-text-dark-black">
          {guest.email
            ? `This guest was added to the guest list because they joined the virtual meeting using the following login:`
            : `This guest was added to the guest list because they joined the virtual meeting.`}
        </div>
        {guest.email && (
          <div className="tw-text-sm tw-font-normal tw-text-primary-grey">{guest.email}</div>
        )}
      </div>
    </>
  );
};
